// extracted by mini-css-extract-plugin
export var actionButton = "_hr-t";
export var buttonContainer = "_hr-0";
export var buttonContainer2 = "_hr-1";
export var buttonSection = "_hr-2";
export var details = "_hr-3";
export var dropdownItem = "_hr-5";
export var dropdownItemsContainer = "_hr-4";
export var fileInput = "_hr-r";
export var headerButton = "_hr-6";
export var icon = "_hr-7";
export var input = "_hr-8";
export var macroListItem = "_hr-9";
export var mainContent = "_hr-a";
export var microText = "_hr-b";
export var modal = "_hr-w";
export var optionsButton = "_hr-c";
export var paperclip = "_hr-s";
export var pillContent = "_hr-d";
export var preview = "_hr-e";
export var preview2 = "_hr-f";
export var quillEditor = "_hr-q";
export var selectedMacro = "_hr-g";
export var sidebar = "_hr-h";
export var sidebarHeader = "_hr-j";
export var sidebarList = "_hr-i";
export var sidebarListItem = "_hr-k";
export var sidebarSearch = "_hr-l";
export var snoozeDurationWrapper = "_hr-v";
export var statusPillContainer = "_hr-m";
export var tagsContainer = "_hr-n";
export var unselectedMacro = "_hr-o";
export var variable = "_hr-u";
export var wrapper = "_hr-p";